<template>
    <template v-if="selected.length > 0">
        <div class="selected-container">
            <template v-if="maxTags === 1 && selected.length > 1">
                <q-chip
                    color="primary"
                    text-color="white"
                    icon-remove="fa-solid fa-circle-xmark"
                    :removable="!disable"
                    @remove="$emit('removeAll')"
                >
                    {{ selected.length }} {{ $t("shared.Selected") }}
                </q-chip>
            </template>
            <template v-else>
                <template v-for="(val, index) in selected" :key="val.id">
                    <q-chip
                        color="primary"
                        text-color="white"
                        icon-remove="fa-solid fa-circle-xmark"
                        v-if="index < maxTags"
                        :removable="!disable"
                        @remove="onRemove(val.id)"
                        :data-qs="`${val.text}-chip`"
                    >
                        <div class="ellipsis">
                            {{ val.text }}
                            <q-tooltip>{{ val.text }}</q-tooltip>
                        </div>
                    </q-chip>
                    <q-chip
                        color="primary"
                        text-color="white"
                        icon-remove="fa-solid fa-circle-xmark"
                        v-if="index === maxTags"
                        :removable="!disable"
                        @remove="onRemove(val.id)"
                    >
                        {{ selected.length - maxTags }} {{ $t("shared.More") }}
                    </q-chip>
                </template>
            </template>
        </div>
    </template>
</template>

<script setup lang="ts">
import { toRefs } from "vue";
import { FacetValue } from "../../facets.model";

const props = defineProps<{
    selected: FacetValue[];
    maxTags: number;
    onRemove: (id: string) => void;
    disable?: boolean;
}>();

defineEmits<{
    (e: "removeAll"): void;
}>();

const { selected } = toRefs(props);
</script>

<style lang="scss" scoped>
.selected-container {
    display: flex;
    flex-wrap: wrap;
    max-width: 400px;
}
.facet-dropdown-multi-field {
    display: flex;
    flex-wrap: wrap;
    min-height: 36px;
}
</style>
